import { Component, EventEmitter, Input, Output } from '@angular/core';

import { PolicySummary } from '@amfam/policy/models';

@Component({
  selector: 'amfam-no-detail-summary',
  templateUrl: './no-detail-summary.component.html',
  styleUrls: ['./no-detail-summary.component.scss'],
  standalone: false
})
export class NoDetailSummaryComponent {
  @Input() title: string;
  @Input() summaries: PolicySummary[];
  @Input() icon: string;
  @Input() isLife: boolean = false;
  @Output() detailButtonClicked = new EventEmitter();
}
